// DisplayMessagePage.jsx
import React from 'react';
// import { useNavigation } from '@react-navigation/native';
import MainLayout from '../layouts/MainLayout';
import '../styles/MessageDisplay.css';

const DisplayMessagePage = ({ location }) => {
    const { formData, image } = route.params;
    const navigation = useNavigation();


    const handleGoBack = () => {
        navigation.goBack();
    };

    return (
        <MainLayout>
            <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
                <h2>Message Share (Life Chronicle - Inviation, Gratitude, Empathy, Sympathy, Regret, Greeting)</h2>
            </div>
            <div>
                {image && (
                    <div>
                        <h2>Uploaded Image</h2>
                        <img src={URL.createObjectURL(image)} alt="Uploaded" style={{ maxWidth: '100%' }} />
                    </div>
                )}
                <div>
                    <h2>Form Data</h2>
                    <ul>
                        {Object.entries(formData).map(([key, value]) => (
                            <li key={key}><strong>{key}:</strong> {value}</li>
                        ))}
                    </ul>
                </div>

                <button onClick={handleGoBack}>Go Back</button>
            </div>
        </MainLayout>
    );
};

export default DisplayMessagePage;
